var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","height":"1em","width":"1em","viewBox":"0 0 48 48","fill":"currentColor"}},[_c('path',{attrs:{"d":"M22.5 40V13.7L10.1 26.1 8 24 24 8l16 16-2.1 2.1-12.4-12.4V40Z","fill":"currentColor"}})])}
var staticRenderFns = []

export { render, staticRenderFns }